import { atom, selector } from 'recoil';
import type { AdvisoryFeeConfig } from 'venn-api';
import { getAdvisoryFeeConfig } from 'venn-api';
import { incrementOnStudioReset, incrementOnWorkspaceConfigurationChange } from '../../effects/signalEffects';

const advisoryFeeConfigQueryId = atom<number>({
  key: 'advisoryFeeConfigQueryId',
  default: 0,
  effects: [incrementOnStudioReset, incrementOnWorkspaceConfigurationChange],
});

export type WorkspaceFeeLimits = {
  defaultFee: number;
  minFee: number;
  maxFee: number;
};

export const advisoryFeeConfigState = selector<AdvisoryFeeConfig | undefined>({
  key: 'advisoryFeeConfigState',
  get: async ({ get }) => {
    get(advisoryFeeConfigQueryId);
    try {
      const { content } = await getAdvisoryFeeConfig();
      return content;
    } catch {
      return undefined;
    }
  },
});

export const displayZeroFeeState = selector<boolean>({
  key: 'displayZeroFeeState',
  get: ({ get }) => {
    const config = get(advisoryFeeConfigState);
    return config?.displayZeroFee ?? false;
  },
});

export const workspaceFeeLimitsState = selector<WorkspaceFeeLimits | undefined>({
  key: 'workspaceFeeLimitsState',
  get: ({ get }) => {
    const config = get(advisoryFeeConfigState);
    if (!config) {
      return undefined;
    }
    return {
      defaultFee: config.defaultFee,
      minFee: config.minFee,
      maxFee: config.maxFee,
    };
  },
});
